import { useCallback, useState } from 'react';
const hasCategories = (videos) => {
    return videos.find(vid => vid.category) !== undefined;
};
const getCategorizedVidIndexes = (videos) => {
    let categorizedVidIndexes = {};
    if (hasCategories(videos)) {
        videos.forEach((vid, idx) => {
            const category = vid.category;
            if (category) {
                const categoryIdxs = (categorizedVidIndexes === null || categorizedVidIndexes === void 0 ? void 0 : categorizedVidIndexes[category]) || [];
                categorizedVidIndexes = {
                    ...categorizedVidIndexes,
                    [category]: [...categoryIdxs, idx],
                };
            }
        });
    }
    return categorizedVidIndexes;
};
export const useCategories = (videos) => {
    var _a;
    const categorizedVidIndexes = getCategorizedVidIndexes(videos);
    const [currentCategory, _setCurrentCategory] = useState((_a = Object.keys(categorizedVidIndexes)) === null || _a === void 0 ? void 0 : _a[0]);
    const setCurrentCategory = useCallback((category = '') => {
        if (hasCategories(videos)) {
            _setCurrentCategory(category);
        }
    }, [videos]);
    return {
        currentCategory,
        setCurrentCategory,
        categories: Object.keys(categorizedVidIndexes),
    };
};
